export default "__VITE_ASSET__Be$mfVML__"